import { apiFetch } from "@/lib/api";

export { WORKSPACE_AVATAR_SYNC_OPERATOR_EMAIL } from "@/lib/workspaceAvatarSync";

export interface QuickBooksTimeOAuthStatus {
  clientConfigured: boolean;
  connected: boolean;
  tokenHealthy: boolean;
  needsReconnect: boolean;
  /** Healthy, but the access token expires within the renewal window. */
  needsReconnectSoon?: boolean;
  operatorEligible: boolean;
  expiresAt: string | null;
  connectedAt: string | null;
  connectedByUserId: string | null;
  connectedByLabel: string | null;
  quickbooksTimeUserId: number | null;
  lastRefreshError: string | null;
}

export function fetchQuickBooksTimeOAuthStatus(): Promise<QuickBooksTimeOAuthStatus> {
  return apiFetch<QuickBooksTimeOAuthStatus>("/api/manufacturing/reporting/quickbooks-time/oauth/status");
}

export function startQuickBooksTimeOAuth(input: {
  returnTo?: string;
  uiOrigin?: string;
}): Promise<{ authorizeUrl: string; expiresAt: string }> {
  return apiFetch("/api/manufacturing/reporting/quickbooks-time/oauth/start", {
    method: "POST",
    body: input,
  });
}

export function disconnectQuickBooksTimeOAuth(): Promise<{ disconnected: boolean }> {
  return apiFetch("/api/manufacturing/reporting/quickbooks-time/oauth/disconnect", {
    method: "POST",
  });
}
